import { Route, Routes, useLocation } from "react-router-dom";
import routes from "./routes/routes";
import { useEffect, useState } from "react";
import Loader from "./common/Loader";

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
    }, 500);  
    return () => clearTimeout(timer);
  }, [location]);
  
  return (
    <div>
      {loading && <Loader />}
      <Routes>
        {routes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
    </div>
  );
}

export default App;
